import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { Smartphone, Code, TrendingUp, Palette, Bot, TestTube2, ArrowRight } from 'lucide-react';
import '../styles/Services.css';

const Services = () => {
  const services = [
    {
      id: 'app-development',
      icon: <Smartphone size={40} />,
      title: 'App Development',
      description: 'Native & cross-platform mobile apps with clean architecture and fast delivery',
      features: [
        'iOS & Android native development',
        'Cross-platform with React Native/Flutter',
        'App Store optimization & launch',
        'Ongoing maintenance & updates'
      ],
      deliverables: 'MVP in 8-12 weeks',
      pricing: 'Fixed project or T&M'
    },
    {
      id: 'web-development',
      icon: <Code size={40} />,
      title: 'Web Development',
      description: 'Scalable web applications built with modern frameworks and best practices',
      features: [
        'React, Next.js, Node.js expertise',
        'Cloud deployment (AWS, Vercel, DigitalOcean)',
        'API development & integration',
        'Performance optimization'
      ],
      deliverables: 'Full-stack web apps in 6-10 weeks',
      pricing: 'Fixed project or retainer'
    },
    {
      id: 'seo',
      icon: <TrendingUp size={40} />,
      title: 'SEO & Growth',
      description: 'Data-driven SEO strategies that increase organic traffic and conversions',
      features: [
        'Technical SEO audit & fixes',
        'On-page & off-page optimization',
        'Content strategy & creation',
        'Analytics & conversion tracking'
      ],
      deliverables: 'Ongoing monthly retainer',
      pricing: 'Monthly retainer'
    },
    {
      id: 'ui-ux',
      icon: <Palette size={40} />,
      title: 'UI/UX Design',
      description: 'User-centered design that converts visitors into customers',
      features: [
        'User research & personas',
        'Wireframing & prototyping',
        'High-fidelity UI design',
        'Design system & component library'
      ],
      deliverables: 'Complete designs in 3-5 weeks',
      pricing: 'Fixed project'
    },
    {
      id: 'ai-ml',
      icon: <Bot size={40} />,
      title: 'AI/ML Solutions',
      description: 'Intelligent systems powered by machine learning and AI',
      features: [
        'ChatGPT & LLM integration',
        'Computer vision & image recognition',
        'Predictive analytics',
        'Custom AI model development'
      ],
      deliverables: 'POC in 4-6 weeks',
      pricing: 'Fixed project or T&M'
    },
    {
      id: 'qa-testing',
      icon: <TestTube2 size={40} />,
      title: 'QA & Testing',
      description: 'Comprehensive testing to ensure quality and reliability',
      features: [
        'Manual & automated testing',
        'Performance & load testing',
        'Security testing',
        'Bug tracking & reporting'
      ],
      deliverables: 'Ongoing testing & QA',
      pricing: 'Hourly or retainer'
    }
  ];

  return (
    <div className="services-page" data-testid="services-page">
      <Navbar />
      
      <section className="services-hero">
        <div className="container">
          <div className="hero-content fade-in-up">
            <h1 className="page-title" data-testid="services-title">Our Services</h1>
            <p className="page-subtitle" data-testid="services-subtitle">
              Full-stack development and digital services to build, launch, and grow your product
            </p>
          </div>
        </div>
      </section>

      <section className="services-list">
        <div className="container">
          <div className="services-grid-detailed">
            {services.map((service, index) => (
              <div className="service-detailed-card card" key={index} data-testid={`service-card-${service.id}`}>
                <div className="service-header">
                  <div className="service-icon-large">{service.icon}</div>
                  <div>
                    <h3>{service.title}</h3>
                    <p className="service-desc">{service.description}</p>
                  </div>
                </div>
                
                <div className="service-features">
                  <h4>What's Included:</h4>
                  <ul>
                    {service.features.map((feature, i) => (
                      <li key={i}>{feature}</li>
                    ))}
                  </ul>
                </div>

                <div className="service-info">
                  <div className="info-item">
                    <span className="info-label">Deliverables:</span>
                    <span className="info-value">{service.deliverables}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Pricing Model:</span>
                    <span className="info-value">{service.pricing}</span>
                  </div>
                </div>

                <Link to={`/services/${service.id}`} className="btn btn-primary" data-testid={`service-detail-btn-${service.id}`}>
                  Learn More
                  <ArrowRight size={18} />
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="services-cta">
        <div className="container">
          <div className="cta-content">
            <h2>Not sure which service you need?</h2>
            <p>Let's discuss your project and find the best solution for your business.</p>
            <Link to="/contact" className="btn btn-primary btn-large" data-testid="services-contact-cta">
              Schedule a Consultation
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

\    </div>
  );
};

export default Services;